<template>
    <div class="datagrid-wrapper">
        <div>
            <div class="row">
                <div class="col-md-12 title-holder">
                    <h1>{{ table_title }}</h1>
                    <div class="grid-buttons" data-type="buttons" v-if="can_sync_companies">
                        <a id="proton-sync-companies-placeholder" class="d-none"></a>
                        <manual-sync-trigger-button :centre="centre_id" sync-type='companies'></manual-sync-trigger-button>
                    </div>
                    <div class="search-form-mask open">
                        <form role="search" method="get" class="form-inline search-form">
                            <div class="form-group">
                                <input v-model.lazy="search" type="search" class="sb-search-input form-control"
                                       placeholder="Search for.."/>
                            </div>
                            <div v-if="this.search">
                                <button @click.prevent="reset" type="reset" class="btn-icon btn-light sb-icon-reset">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">Reset</span>
                                </span>
                                </button>
                            </div>
                            <button @click.prevent="getCompanies" type="submit" class="btn btn-light sb-icon-search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <div v-if="header === 'company id'">
                                <button type="button" class="btn btn-link"  @click="sortBy('companies.titan_id')">{{ header }} &#8597;</button>
                            </div>
                            <div v-else-if="header === 'company name'">
                                <button type="button" class="btn btn-link"  @click="sortBy('companies.name')">{{ header }} &#8597;</button>
                            </div>
                            <div v-else-if="header === 'status'">
                                <button type="button" class="btn btn-link"  @click="sortBy('companies.active')">{{ header }} &#8597;</button>
                            </div>
                            <div v-else>
                                <span class="btn-link">{{ header }}</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!companies.data">
                        <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!companies.data.length">
                        <td :colspan="table_headers.length">No companies found</td>
                    </tr>
                    <tr v-for="company in companies.data" v-bind:key="company.id" ref="companyRows">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'name'">
                                <a :href="`/companies/${company.id}`">{{ company.name }}</a>
                            </div>
                            <div v-else-if="column === 'status'" v-html="statusHtml(company.status)"></div>
                            <div v-else-if="column === 'primary_contacts'" v-for="contact in company.primary_contacts">
                                <a :href="`/employees/${contact.id}`" data-bs-toggle="tooltip" data-bs-html="true"
                                   :title="tooltipHtml(contact)">
                                    {{ contact.name }}
                                </a><br/>
                            </div>
                            <div v-else v-html="company[column]"></div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="companies" :limit=3 @pagination-change-page="getCompanies">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import manualSyncTriggerButton from '../Sync/ManualSyncTriggerButton.vue'
import {initTooltips} from "../../Services/Tooltip";

export default {
    name: "CompaniesDataTable",
    components: {
        manualSyncTriggerButton
    },
    props: {
        centre_id: {
            type: Number,
        },
        can_sync_companies: {
            type: Boolean,
        },
        api_endpoint: {
            type: String,
        },
        table_title: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
        filter_roles: {
            type: Object,
        },
        primary_contacts: {
            type: Array,
        }
    },
    data() {
        return {
            companies: {},
            paginate: 10,
            search: '',
            sort_key: 'companies.titan_id',
            reverse: false,
        }
    },
    watch: {
        paginate: function (value) {
            this.getCompanies();
        }
    },
    methods: {
        statusHtml(status) {
            let cssClass, text;

            if (status === 'blocked') {
                cssClass = 'text-danger';
                text = 'blocked';
            }
            else if (status === 'inactive') {
                cssClass = 'text-inactive';
                text = 'inactive';
            } else {
                cssClass = 'text-active';
                text = 'active';
            }

            return '<span class="' + cssClass + '">' + text + '</span>';
        },
        tooltipHtml(contact) {
            let tooltip = '';

            if (contact.name) {
                tooltip += contact.name + '<br/>';
            }
            if (contact.email) {
                tooltip += contact.email + '<br/>';
            }
            if (contact.phone) {
                tooltip += contact.phone + '<br/>';
            }

            return tooltip;
        },
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? ! this.reverse : false;
            this.sort_key = sort_key;
            this.getCompanies();
        },
        initTooltips() {
            this.$nextTick(() => {
                this.$refs.companyRows.forEach((row) => {
                    let tooltipTriggerList = row.querySelectorAll('[data-bs-toggle="tooltip"]');
                    initTooltips(tooltipTriggerList);
                });
            });
        },
        getCompanies(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    q: this.search,
                    sort_key: this.sort_key,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
                .then(response => {
                    this.companies = response.data;
                    this.initTooltips();
                });
        },
        reset() {
            this.search = '';
            this.getCompanies();
        },
    },
    created() {
        this.getCompanies();
    }
}
</script>
<style scoped>
.btn-link,.btn-link:hover {
    letter-spacing: normal;
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
    white-space: nowrap;
}
</style>
